const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M267.538 191.284c-4.986-8.54-11.748-15.302-20.288-20.287-8.543-4.985-17.867-7.476-27.983-7.476-10.114 0-19.441 2.491-27.982 7.476-8.541 4.984-15.303 11.746-20.288 20.288-4.986 8.541-7.478 17.869-7.478 27.982 0 10.114 2.493 19.44 7.477 27.982 4.985 8.54 11.747 15.303 20.288 20.288 8.542 4.984 17.869 7.476 27.982 7.476 10.114 0 19.442-2.492 27.983-7.476 8.54-4.984 15.303-11.747 20.287-20.288 4.984-8.541 7.476-17.869 7.476-27.982 0-10.114-2.492-19.442-7.474-27.983zm-14.083 47.799c-3.533 6.048-8.323 10.839-14.372 14.373-6.048 3.533-12.653 5.297-19.816 5.297-7.162 0-13.767-1.765-19.816-5.297-6.05-3.534-10.84-8.325-14.372-14.373-3.533-6.05-5.299-12.654-5.299-19.816 0-7.162 1.766-13.767 5.299-19.816 3.532-6.05 8.323-10.84 14.372-14.372 6.048-3.533 12.654-5.3 19.816-5.3 7.162 0 13.768 1.767 19.816 5.3 6.05 3.532 10.84 8.323 14.372 14.372 3.532 6.049 5.298 12.654 5.298 19.816 0 7.162-1.765 13.767-5.298 19.816z"
});

const SvgCircle = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438.533,
    height: 438.533,
    viewBox: "0 0 438.533 438.533",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle.0c98dcb8.svg";
export { ForwardRef as ReactComponent };